<div class="row px-1">
  <div class="only-button d-flex justify-content-end container-style px-2 py-">
    <app-custom-button class="button-new-register" [width]="'5rem'" [title]="'Nuevo'" [label]="'Nuevo'"
      [severity]="'success'" [variant]="undefined" [icon]="'pi pi-plus'" [width]="'5.5rem'"
      (onClick)="newUser()"></app-custom-button>
  </div>
</div>
<div *ngIf="!isOpened" class="container-style mt-2">
  <app-custom-table [showExport]="true" [showRecover]="true" [headers]="header" [data]="data" [actions]="tableActions"
    [previousFilters]="filters" [filterPersistentKey]="'user'" (onRecoverData)="getUsersWithPagination()"
    (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)" (onExport)="exportConsultation()"
    (onAction)="onAction($event)">
  </app-custom-table>
</div>
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>